<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 状态 -->

      <!-- 标题 -->
      <a-form-model-item :label="$t('system.title')" prop="noticeTitleIn">
        <a-input v-model="form.noticeTitleIn" :placeholder="$t('system.inputTitle')" :maxLength="250" />
      </a-form-model-item>
      <!-- 标题(英文) -->
      <a-form-model-item :label="$t('system.titleEn')" prop="noticeTitleEn">
        <a-input v-model="form.noticeTitleEn" :placeholder="$t('system.inputTitleEn')" :maxLength="250" />
      </a-form-model-item>
      <!-- 标题(法语) -->
      <a-form-model-item :label="$t('system.titleCn')" prop="noticeTitleCn">
        <a-input v-model="form.noticeTitleCn" :placeholder="$t('system.inputTitleCn')" :maxLength="250" />
      </a-form-model-item>
      <!-- 标题(阿拉伯) -->
      <a-form-model-item :label="$t('system.titleArabic')" prop="noticeTitle">
        <a-input v-model="form.noticeTitle" :placeholder="$t('system.inputTitleArabic')" :maxLength="50" />
      </a-form-model-item>
      <!-- 内容 -->
      <a-form-model-item :label="$t('system.content')" prop="noticeContentIn">
        <editor :editorValue="'noticeContentIn'" :configValue="'noticeContentIn'" v-model="form.noticeContentIn" />
      </a-form-model-item>
      <!-- 内容(英文) -->
      <a-form-model-item :label="$t('system.contentEn')" prop="noticeContentEn">
        <editor :editorValue="'noticeContentEn'" :configValue="'noticeContentEn'" v-model="form.noticeContentEn" />
      </a-form-model-item>
      <!-- 内容(法语) -->
      <a-form-model-item :label="$t('system.contentCn')" prop="noticeContentCn">
        <editor :editorValue="'noticeContentCn'" :configValue="'noticeContentCn'" v-model="form.noticeContentCn" />
      </a-form-model-item>
      <!-- 内容(阿拉伯) -->
      <a-form-model-item :label="$t('system.contentArabic')" prop="noticeContent">
        <editor :editorValue="'noticeContent'" :configValue="'noticeContent'" v-model="form.noticeContent" />
      </a-form-model-item>
      <!-- 底部操作按钮 -->
      <a-form-model-item :label="$t('system.status')" prop="status">
        <!--        <a-select v-model="form.status" placeholder="请选择" style="width: 200px;">-->
        <!--          <a-select-option :value="0">禁用</a-select-option>-->
        <!--          <a-select-option :value="1">正常</a-select-option>-->
        <!--        </a-select>-->

        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(d, index) in dict.type['sys_enable_disable']" :key="index" :value="parseInt(d.value)">{{ d.label }}</a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getNotice, addNotice, updateNotice } from '@/api/system/notice'
import Editor from '@/components/Editor'

export default {
  name: 'NoticeForm',
  components: {
    Editor
  },
  dicts: ['sys_enable_disable'],
  data() {
    return {
      // 提交加载状态
      submitLoading: false,
      // 表单类型：1-新增，2-修改
      formType: 1,
      // 抽屉显示状态
      open: false,
      // 表单数据
      form: {
        id: null,
        noticeTitle: null,
        noticeTitleEn: null,
        noticeTitleCn: null,
        noticeTitleBm: null,
        noticeTitleIn: null,
        noticeType: null,
        noticeContent: '',
        noticeContentEn: '',
        noticeContentCn: '',
        noticeContentBm: '',
        noticeContentIn: '',
        status: 1,
        bstatus: 1
      }
    }
  },
  computed: {
    formTitle() {
      return this.formType === 1 ? this.$t('system.addNotice') : this.$t('system.editNotice')
    },
    rules() {
      return {
        noticeTitle: [{ required: true, message: this.$t('system.titleArabicRequired') }],
        noticeTitleEn: [{ required: true, message: this.$t('system.titleEnRequired') }],
        noticeTitleCn: [{ required: true, message: this.$t('system.titleCnRequired') }],
        noticeTitleIn: [{ required: true, message: this.$t('system.titleRequired') }],
        noticeContent: [{ required: true, message: this.$t('system.contentArabicRequired') }],
        noticeContentEn: [{ required: true, message: this.$t('system.contentEnRequired') }],
        noticeContentCn: [{ required: true, message: this.$t('system.contentCnRequired') }],
        noticeContentIn: [{ required: true, message: this.$t('system.contentRequired') }]
      }
    }
  },
  methods: {
    /**
     * 表单重置
     */
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        noticeTitle: null,
        noticeTitleEn: null,
        noticeTitleCn: null,
        noticeTitleBm: null,
        noticeTitleIn: null,
        noticeType: null,
        noticeContent: '',
        noticeContentEn: '',
        noticeContentCn: '',
        noticeContentBm: '',
        noticeContentIn: '',
        status: 1,
        bstatus: 1
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    /**
     * 新增按钮操作
     */
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
    },
    /**
     * 修改按钮操作
     * @param {Object} row - 行数据
     * @param {Number|String} ids - ID（备用参数）
     */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getNotice(id).then(response => {
        const str = response.data.status
        this.$set(response.data, 'bstatus', str)
        this.form = response.data
        this.open = true
      })
    },
    /**
     * 提交表单
     */
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          // 使用 $nextTick 确保 Editor 组件的值已经更新到 form 中
          this.$nextTick(() => {
            // 手动构建表单数据，确保所有字段都有值（将 undefined 转换为 null）
            const formData = {
              id: this.form.id !== undefined ? this.form.id : null,
              noticeTitle: this.form.noticeTitle !== undefined && this.form.noticeTitle !== null ? this.form.noticeTitle : '',
              noticeTitleEn: this.form.noticeTitleEn !== undefined && this.form.noticeTitleEn !== null ? this.form.noticeTitleEn : '',
              noticeTitleCn: this.form.noticeTitleCn !== undefined && this.form.noticeTitleCn !== null ? this.form.noticeTitleCn : '',
              noticeTitleBm: this.form.noticeTitleBm !== undefined && this.form.noticeTitleBm !== null ? this.form.noticeTitleBm : '',
              noticeTitleIn: this.form.noticeTitleIn !== undefined && this.form.noticeTitleIn !== null ? this.form.noticeTitleIn : '',
              noticeType: this.form.noticeType !== undefined ? this.form.noticeType : null,
              noticeContent: this.form.noticeContent !== undefined && this.form.noticeContent !== null ? this.form.noticeContent : '',
              noticeContentEn: this.form.noticeContentEn !== undefined && this.form.noticeContentEn !== null ? this.form.noticeContentEn : '',
              noticeContentCn: this.form.noticeContentCn !== undefined && this.form.noticeContentCn !== null ? this.form.noticeContentCn : '',
              noticeContentBm: this.form.noticeContentBm !== undefined && this.form.noticeContentBm !== null ? this.form.noticeContentBm : '',
              noticeContentIn: this.form.noticeContentIn !== undefined && this.form.noticeContentIn !== null ? this.form.noticeContentIn : '',
              status: this.form.status !== undefined ? this.form.status : 1,
              bstatus: this.form.bstatus !== undefined ? this.form.bstatus : 1
            }

            if (formData.id !== null && formData.id !== undefined) {
              // 修改
              updateNotice(formData).then(response => {
                this.$message.success(this.$t('common.updateSuccess'), 3)
                this.open = false
                this.$emit('ok')
              }).finally(() => {
                this.submitLoading = false
              })
            } else {
              // 新增
              addNotice(formData).then(response => {
                this.$message.success(this.$t('common.addSuccess'), 3)
                this.open = false
                this.$emit('ok')
              }).finally(() => {
                this.submitLoading = false
              })
            }
          })
        } else {
          return false
        }
      })
    },
    /**
     * 取消操作
     */
    cancel() {
      this.open = false
      this.reset()
    },
    /**
     * 关闭抽屉
     */
    onClose() {
      this.open = false
      this.reset()
    }
  }
}
</script>

<style scoped lang="less">

</style>
